import { render, staticRenderFns } from "./pointOrderConfirm.vue?vue&type=template&id=122c0c1c&scoped=true&"
import script from "./pointOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./pointOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./pointOrderConfirm.vue?vue&type=style&index=0&id=122c0c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122c0c1c",
  null
  
)

export default component.exports